export const SET_MESSAGE_TEMPLATE_MODE = 'SET_MESSAGE_TEMPLATE_MODE';
export const SET_ACTIVE_MESAGE_TEMPLATE = 'SET_ACTIVE_MESAGE_TEMPLATE';